import { storageClient } from '../apis/client-instances';

/**
 * ✅ Show notification
 */
export const alert = (enqueueSnackbar, text, status) => {
  return enqueueSnackbar(text, {
    variant: status,
    autoHideDuration: 3000,
    anchorOrigin: { vertical: 'top', horizontal: 'right' },
  });
};

/**
 * ✅ Upload a file using SAS token
 */

export const getFileUrl = async (url) => {
  if (!url) return undefined;

  // If the value is already an absolute URL (external image, etc.),
  // return it as-is. The server's get-file-url endpoint only handles
  // blob names, not full URLs.
  if (/^https?:\/\//i.test(url)) return url;

  const downloadUrl = await storageClient.getFileUrl(url);
  return downloadUrl;
};

export const uploadFile = async (file) => {
  try {
    if (!file) return;
    // Extract extension (without dot)
    const extMatch = file.name.match(/\.([^.]+)$/);
    const extension = extMatch ? extMatch[1] : '';

    const fileResponse = await storageClient.generateSas(extension);
    const { sasUrl } = fileResponse;

    console.log('Uploading to:', sasUrl);

    const response = await fetch(sasUrl, {
      method: 'PUT',
      headers: {
        'x-ms-blob-type': 'BlockBlob',
        'Content-Type': file.type || 'application/octet-stream',
      },
      body: file,
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Upload failed: ${response.status} - ${errorText}`);
    }

    console.log('Upload successful:', sasUrl);
    return { success: true, uploadedUrl: fileResponse.filename };
  } catch (error) {
    console.error('uploadFile error:', error);
    return { success: false, error: error.message };
  }
};
